module.exports = __webpack_public_path__ + "static/c5-e6ed0d1fe5e131646d1392835057c144.png";